import { fetchEventSource } from '@microsoft/fetch-event-source';
import { API_BASE_URL, getStoredAccessToken, refreshAccessToken } from '@/api/request';

export function subscribeToNotifications(onNotification: () => void) {
  const controller = new AbortController();
  const headers: Record<string, string> = {
    Accept: 'text/event-stream',
  };
  const token = getStoredAccessToken();
  if (token)
    headers.Authorization = `Bearer ${token}`;

  void fetchEventSource(`${API_BASE_URL}/api/notifications/stream/`, {
    method: 'GET',
    headers,
    signal: controller.signal,
    openWhenHidden: true,
    async onopen(response) {
      if (response.status === 401) {
        let refreshedToken: string;
        try {
          refreshedToken = await refreshAccessToken();
        }
        catch (error) {
          controller.abort();
          throw error;
        }
        headers.Authorization = `Bearer ${refreshedToken}`;
        throw new Error('Notification stream token refreshed');
      }
      if (!response.ok || !response.headers.get('content-type')?.includes('text/event-stream'))
        throw new Error(`Notification stream unavailable (${response.status})`);
    },
    onmessage(message) {
      if (message.event === 'notification')
        onNotification();
    },
    onclose() {
      if (!controller.signal.aborted)
        throw new Error('Notification stream reconnecting');
    },
    onerror(error) {
      if (controller.signal.aborted)
        throw error;
      return 2_000;
    },
  }).catch(() => {
    // The existing polling timers remain active as the transport fallback.
  });

  return controller;
}
